import { FC } from "react";
import { useTranslation } from "react-i18next";

import { IProductionChainPreviewStep } from "@ryde/shared";

import { GroupTitleTemplate } from "../../../dynamic-forms";
import { ProductionChainStepPreview } from "./production-chain-step-preview";

interface IProductionChainsStepPreviewProps {
  chainSteps: IProductionChainPreviewStep[];
}

export const ProductionChainsStepPreview: FC<
  IProductionChainsStepPreviewProps
> = ({ chainSteps }) => {
  const { t } = useTranslation();
  const nextChainSteps = chainSteps.slice(1);

  return (
    <>
      {Boolean(nextChainSteps.length) && (
        <GroupTitleTemplate
          name="nextChainSteps"
          labelTranslated={`${t("rideProduction.nextProductionChains")} (${
            nextChainSteps.length
          })`}
        />
      )}

      {nextChainSteps.map(chainStep => (
        <ProductionChainStepPreview
          key={chainStep.chainLevel}
          chainStep={chainStep}
        />
      ))}
    </>
  );
};
